import type { DeepPartial } from '@luna/utils-ts';
import type { CardsFeatureConfig } from '@shared/cards-config';

import {
    CardBlockingFeatureConfig,
    CardCancellationFeatureConfig,
    CardLimitsChangeFeatureConfig,
    CardLockAndReplaceFeatureConfig,
    CardLockFeatureConfig,
    CardLoyaltyProgramExternalFeatureConfig,
    CardMigrationExternalFeatureConfig,
    CardsBankListFeatureConfig,
    CardsCreditLimitChangeFeatureConfig,
    CardsCreditLimitInfoFeatureConfig,
    CardsSettingsCardDetailsFeatureConfig,
    CreditCardContentBoxFeatureConfig,
    CreditCardReissueExternalFeatureConfig,
    CreditCardRepaymentMethodChangeExternalFeatureConfig,
    CreditSharedFeatureConfig,
    DebitCardContentBoxFeatureConfig,
    InstallmentsActivationFeatureConfig,
    cardsCreditLimitChangeExternalFeatureConfig,
} from './featureConfig';

export const cards: DeepPartial<CardsFeatureConfig> = {
    isNativeAliasChangeAllowed: true,
    components: {
        cardServicesList: {},
        installmentsActivation: InstallmentsActivationFeatureConfig.AT,
        creditCardLimitChange: CardsCreditLimitChangeFeatureConfig.AT,
        creditCardLimitInfo: CardsCreditLimitInfoFeatureConfig.AT,
        cardLockAndReplace: CardLockAndReplaceFeatureConfig.AT,
        cardLoyaltyProgramExternal: CardLoyaltyProgramExternalFeatureConfig.AT,
        cardMigrationExternal: CardMigrationExternalFeatureConfig.AT,
        creditCardReissueExternal: CreditCardReissueExternalFeatureConfig.AT,
        creditCardRepaymentMethodChangeExternal:
            CreditCardRepaymentMethodChangeExternalFeatureConfig.AT,
        cardsCreditLimitChangeChangeExternal: cardsCreditLimitChangeExternalFeatureConfig.AT,
        cardBlocking: CardBlockingFeatureConfig.AT,
        cardsList: CardsBankListFeatureConfig.AT,
        cardLock: CardLockFeatureConfig.AT,
        limitsChange: CardLimitsChangeFeatureConfig.AT,
        settings: {
            cardDetails: CardsSettingsCardDetailsFeatureConfig.AT,
        },
        cardCancellation: CardCancellationFeatureConfig.AT,
        creditCardContentBox: CreditCardContentBoxFeatureConfig.AT,
        debitCardContentBox: DebitCardContentBoxFeatureConfig.AT,
    },
    bank: {
        supplementary: {
            enabled: true,
        },
        showAsProduct: true,
    },
    bank_card: {
        settings: {
            allowPersonalization: false,
        },
    },
    credit: CreditSharedFeatureConfig.AT,
    overview: {
        BANK_CARD: {
            MAIN: {
                hide: true,
            },
            AUTHORIZED: {
                hide: true,
            },
            AUTHORIZED_STANDALONE: {
                hide: true,
            },
            hide: true,
        },
    },
    shared: {
        settings: {
            sos: {
                editable: true,
                showInfo: true,
            },
            reissue: {
                pin: {
                    fees: {
                        enabled: true,
                        types: ['BANK_CARD', 'INDOOR'],
                    },
                    deliveryModes: {
                        enabled: true,
                    },
                },
            },
        },
        functions: {
            tpLimits: {
                version: 1,
                limitChangeVersion: 1,
            },
            limitChange: {
                displayTotalLimitFormFieldOnly: true,
            },
        },
    },
};
